import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.replace";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import env from '@tencent/vft-common/env';
import accountCheck from '@tencent/vft-common/openapp/openapp-account-check';
import Clipboard from '@tencent/vft-common/clipboard';
import { buildUrl } from '@tencent/vft-atom/util';
import Vue from 'vue';
import dialogPlugin from '@tencent/vft-vue-plugins/src/dialog';

function removeHttp(src) {
  if (!src) return src; // eslint-disable-next-line no-param-reassign

  src = src.replace('p.qpic.cn', 'puep.qpic.cn');
  return src.replace(/^http(s?):/, '');
}

function isPad() {
  return env.isIpad || env.isApad;
} // 手机端


function isPhone() {
  return env.isIphone || env.isAndroid && !env.isApad;
}

function replaceUrl(href) {
  if (!href) {
    return;
  }

  var _window = window,
      location = _window.location;

  try {
    // eslint-disable-next-line no-param-reassign
    href = location.protocol + removeHttp(href);
    location.replace(href);
  } catch (e) {
    console.error(e);
  }
}

function hackLitApp() {
  var result = false;

  try {
    if (env.isLiteApp) {
      result = true;
      Vue.use(dialogPlugin); // Vue 自动检测是否重复安装

      Vue.prototype.alert({
        msg: '请到腾讯视频APP内参与',
        confirmText: '前往腾讯视频APP',
        confirm: function confirm() {
          accountCheck.openApp(window.location.href);
        }
      });
    }
  } catch (e) {
    console.log(e);
  }

  return result;
}

function hackWeibo() {
  var result = false;
  var ua = navigator.userAgent;
  var regTxt = 'weibo';
  var reg = new RegExp(regTxt, 'i');
  var isWeibo = reg.test(ua);

  try {
    if (isWeibo) {
      result = true;
      Vue.use(dialogPlugin); // Vue 自动检测是否重复安装

      var showAlert = function showAlert() {
        Vue.prototype.alert({
          msg: '请复制链接前往微信参与活动',
          confirmText: '复制链接',
          confirm: function () {
            var _confirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
              return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      // eslint-disable-next-line no-new
                      new Clipboard({
                        text: window.location.href,
                        success: function success() {
                          Vue.prototype.toast('已复制链接');
                        },
                        error: function error() {
                          Vue.prototype.toast('暂不支持复制功能，可手动分享此页面到微信打开或者直接复制该页面地址！');
                        }
                      });
                      showAlert(); // 一直弹出alert，避免用户操作

                    case 2:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));

            function confirm() {
              return _confirm.apply(this, arguments);
            }

            return confirm;
          }()
        });
      };

      showAlert();
    }
  } catch (e) {
    console.log(e);
  }

  return result;
}

function checkLitAppAndWeiBo() {
  hackLitApp();
  hackWeibo();
}

export default function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      padUrl = _ref.padUrl,
      padPic = _ref.padPic,
      pcUrl = _ref.pcUrl;

  var callback = arguments.length > 1 ? arguments[1] : undefined;

  if (isPhone()) {
    // eslint-disable-next-line no-unused-expressions
    callback && callback();
    checkLitAppAndWeiBo();
  } else if (isPad()) {
    // eslint-disable-next-line no-unused-expressions
    padUrl ? replaceUrl(removeHttp(padUrl)) : new Vue({
      render: function render(h) {
        var dftUrl = buildUrl('https://pay.video.qq.com/fcgi-bin/qrencode', {
          url: encodeURIComponent(buildUrl(window.location.href, {
            ptag: 'sharepicqrcode'
          })),
          isNeedShort: 1,
          margin: 2
        });
        return h('div', {
          style: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgb(51, 51, 51)'
          }
        }, [h('img', {
          style: {
            maxWidth: '90%',
            position: 'absolute',
            top: '50%',
            left: '50%',
            opacity: 1,
            transform: 'translate3d(-50%, -50%, 0)',
            '-webkit-transform': 'translate3d(-50%, -50%, 0)'
          },
          attrs: {
            src: padPic || dftUrl
          }
        })]);
      }
    }).$mount('#app');
  } else if (pcUrl) {
    replaceUrl(pcUrl);
  } else {
    // eslint-disable-next-line no-unused-expressions
    callback && callback();
  }
}